<template>
    <div class="luxury-home-page" style="min-height: 80vh;">
        <div class="main-container product-section">
            <el-row :gutter="60">
                <!-- 左侧：图片展示区 -->
                <el-col :xs="24" :sm="24" :md="11" :lg="11">
                    <div class="main-image-wrapper" v-if="imageList.length > 0 && !ClickPic">
                        <video ref="player" autoplay muted style="height: 100%; width: 100%;" @ended="handleVideoEnded"
                            v-if="isVideoShow && videoArr.length > 0" :key="videoIndex" :src="currentVideoUrl"
                            @contextmenu.prevent>
                        </video>
                        <el-carousel v-else @change="ActiveItemChange" :indicator-position="'none'" ref="myCarousel"
                            :interval="3000" :autoplay="isAutoPlay" arrow="never" :height="bannerHeight">
                            <el-carousel-item v-for="item in picArr" :key="item">
                                <div style="width: 100%; height: 100%;">
                                    <img :src="bigFile(websiteImg, item, 1000)" ref="bannerImg" @load="imgLoad"
                                        alt="thumb" style="width: 100%; height: auto; display: block;" />
                                </div>
                            </el-carousel-item>
                        </el-carousel>
                    </div>

                    <div class="main-image-wrapper1" v-else>
                        <transition name="fade">
                            <img :src="ClickPic" alt="thumb" :key="ClickPic" v-if="ClickPic" />
                        </transition>
                    </div>
                    <!-- 缩略图列表(主图)-->
                    <div class="thumb-list" v-if="imageList && imageList.length > 0">
                        <div v-for="(img, index) in imageList" :key="index" class="thumb-item"
                            :class="{ active: currentImgIndex == index }" @click="ImgListClick(index)">
                            <img :src="imageUtils(websiteImg, img)" alt="thumb" v-if="imageList" />
                            <i class="el-icon-video-play play-icon" v-if="index < videoArr.length"></i>
                        </div>
                    </div>
                    <!-- <div class="thumb-list" v-else>
                        <div v-for="(img, index) in smallPic" :key="index" class="thumb-item" v-loading="loading"
                            :class="{ active: currentImgIndex == index }" @click="currentImgIndex = index">
                            <img :src="imageUtils(websiteImg, img)" alt="thumb" />
                        </div>
                    </div> -->
                </el-col>

                <!-- 右侧：详情与选项区 -->
                <el-col :xs="24" :sm="24" :md="13" :lg="13">
                    <div class="product-info">
                        <h1 class="product-title">{{ productInfo.productName }}</h1>
                        <div class="tags"
                            v-if="productInfo.productLabelPojoList && productInfo.productLabelPojoList.length > 0">
                            <span v-for="(value, index) in productInfo.productLabelPojoList" :key="index">{{
                                value.labelContent }}</span>
                        </div>
                        <p class="product-desc production-desc" v-html="productInfo.remark">
                        </p>
                        <!-- 规格选择 -->
                        <div class="section-block">
                            <h3 class="section-label">Fabric</h3>
                            <div class="fabric-grid">
                                <div v-for="(val, index) in productInfo.productColorPojoList" :key="index"
                                    class="fabric-item-wrapper" @click="selectFabric(index, val)">
                                    <div class="fabric-img-box" :class="selectedFabric == index && 'is-selected'">
                                        <el-tooltip class="item" effect="dark" placement="bottom"
                                            :disabled="screenWidth < 768" popper-class="custom-tooltip">
                                            <div slot="content">
                                                <div class="tooltip-img">
                                                    <img :src="imageUtils(websiteImg, val.cover)" alt="Product Image" />
                                                </div>
                                                <div class="fabric-name lineBreak" style="text-align: center;">{{
                                                    val.colorContent
                                                    }}</div>
                                            </div>
                                            <img :src="imageUtils(websiteImg, val.cover)" alt="Product Image" />
                                        </el-tooltip>
                                    </div>
                                    <div class="fabric-name">{{ val.colorContent }}</div>
                                </div>
                            </div>
                        </div>

                        <!-- Control 系统选择 -->
                        <div class="section-block"
                            v-if="productInfo.productCraftList && productInfo.productCraftList.length > 0">
                            <h3 class="section-label">{{ productInfo.type == 0 ? 'Header' : 'Control' }}</h3>
                            <div class="fabric-grid">
                                <div v-for="(val, index) in productInfo.productCraftList" :key="index"
                                    class="fabric-item-wrapper">
                                    <!-- @click="selControl = index" -->
                                    <!-- :class="selControl == index && 'is-selected'" -->
                                    <div class="fabric-img-box">
                                        <el-tooltip class="item" effect="dark" placement="bottom"
                                            :disabled="screenWidth < 768" popper-class="custom-tooltip">
                                            <div slot="content">
                                                <div class="tooltip-img">
                                                    <img :src="imageUtils(websiteImg, val.cover)" alt="Product Image" />
                                                </div>
                                                <div class="fabric-name lineBreak" style="text-align: center;">{{
                                                    val.craftTitle
                                                    }}</div>
                                            </div>
                                            <img :src="imageUtils(websiteImg, val.cover)" alt="Product Image" />
                                        </el-tooltip>
                                    </div>
                                    <div class="fabric-name">{{ val.craftTitle }}</div>
                                </div>
                            </div>
                        </div>

                        <!-- 生产信息 -->
                        <div class="production-info" v-if="productInfo.makeInterval">
                            <h3 style="margin-bottom: 15px;" class="section-label">Production Interval</h3>
                            <div v-html="productInfo.makeInterval" class="production-desc"></div>
                        </div>

                        <!-- 按钮 -->
                        <button class="cta-button" @click="handleOrderClick">PLACE ORDER NOW</button>
                    </div>
                </el-col>
            </el-row>
        </div>

        <!-- 3.详情 -->
        <div style="background: #fff;">
            <div v-if="productInfo && productInfo.productDetailsImageList" class="detail-section">
                <div v-for="(img, index) in productInfo.productDetailsImageList" :key="index">
                    <video ref="player" v-if="isVideo(img.fileName)" autoplay muted
                        style="height: 100%; width: 100%; display: block;" :src="myVideo + img.fileName"
                        @contextmenu.prevent>
                    </video>
                    <el-image style="width: 100%; display: block; min-height: 200px;" v-else
                        :src="bigFile(websiteImg, img.fileName, screenWidth)" alt="Product Image" lazy>
                        <div slot="placeholder" class="image-slot">
                            <i class="el-icon-loading"></i> Loading...
                        </div>
                        <div slot="error" class="image-slot">
                            <i class="el-icon-picture-outline"></i>
                        </div>
                    </el-image>
                </div>

            </div>
        </div>
        <!-- 4.订单说明弹窗 -->
        <el-dialog :visible.sync="orderShow" :width="screenWidth < 768 ? '90%' : '500px'" :append-to-body="true"
            :close-on-click-modal="false">
            <div class="orderTitle">
                {{ isLogin ? 'Contact Us' : 'Instructions' }}
            </div>
            <div class="orderTxt" v-if="!isLogin">
                Please log in to your account and communicate with customer service about the product before placing an
                order.
            </div>
            <div class="orderTitle" v-if="!isLogin" style="margin-top: 20px;">
                Contact Us
            </div>
            <div class="phoneInfo">
                <div>
                    <i class="el-icon-phone"></i>
                    <div>
                        <div>+86-574-62130152</div>
                        <div>13345950296</div>
                    </div>
                </div>
                <div>
                    <i class="el-icon-location-outline"></i>
                    <div>
                        <div>service@alyhomeus.com</div>
                    </div>
                </div>
            </div>
            <!-- <div style="text-align: center;">
                <el-button class="submit-btn" :style="{ 'width': screenWidth > 768 ? '380px' : '100%' }"
                    @click="goLogin()" v-if="!isLogin">CONTINUE</el-button>
            </div> -->
        </el-dialog>

    </div>
</template>

<script>
import { imageUtils, bigFile, blhcImageCopy } from '@/utils/imageUtil';
import utils from '@/utils/util.js';
import { productLibraryDetails } from '@/api/goods';
import Cookies from "js-cookie";
import { mapGetters } from "vuex";

export default {
    name: 'ProductPage',
    data() {
        return {
            websiteImg: utils.websiteImg,
            myVideo: utils.myVideo,
            productInfo: {},
            currentImgIndex: 0,
            selectedFabric: 0, // 默认选中第三个
            selControl: 0, // 默认选中第三个
            smallPic: [],
            orderShow: false,
            ClickPic: '',
            isLogin: false,
            loading: false,
            imageList: [],
            videoArr: [],
            videoIndex: 0,
            isVideoShow: true,
            isAutoPlay: true,
            picArr: [],
            bannerHeight: '500px',
        };
    },
    computed: {
        currentMainImage(imgName) {
            // if (this.ClickPic && this.imageList) {
            //     return bigFile(this.websiteImg, this.ClickPic);
            // }
            // let imgName = '';
            // if (this.productInfo && this.imageList) {
            //     // 添加长度检查，确保数组不为空
            //     if (this.imageList.length > 0) {
            //         imgName = this.imageList[this.currentImgIndex]?.fileName || '';
            //     }
            // } else if (this.smallPic && this.smallPic.length > 0 && this.smallPic[this.currentImgIndex]) {
            //     imgName = this.smallPic[this.currentImgIndex];
            // }
            const reqWidth = this.screenWidth < 768 ? 750 : 1000;
            return bigFile(this.websiteImg, imgName, reqWidth);
        },
        currentVideoUrl() {
            if (this.videoArr.length == 0) return '';
            return this.myVideo + this.videoArr[this.videoIndex];
        },
        ...mapGetters("app", ["getScreenWidth", "isMobile"]),
        screenWidth() {
            return this.getScreenWidth;
        },
    },
    mounted() {
        window.addEventListener('resize', this.handleResize);
        let productId = this.$route.query.product || '';
        this.getInfo(productId);
    },
    watch: {
        '$route.query.product': {
            handler(newProductId) {
                if (newProductId) {
                    this.getInfo(newProductId);
                }
            },
            immediate: false
        }
    },
    methods: {
        imageUtils,
        bigFile,
        blhcImageCopy,
        ActiveItemChange(index) {
            this.currentImgIndex = this.videoArr.length + index;
            if (this.currentImgIndex == this.imageList.length - 1 && this.isAutoPlay) {
                setTimeout(() => {
                    this.currentImgIndex = 0;
                    this.isVideoShow = true;
                    this.videoIndex = 0;
                }, 3000);
            }
            this.imgLoad();
        },
        imgLoad() {
            this.$nextTick(() => {
                if (this.$refs.bannerImg && this.$refs.bannerImg.length > 0) {
                    const img = this.$refs.bannerImg[0];
                    const height = img.clientHeight;
                    if (height && height > 0) {
                        this.bannerHeight = height + 'px';
                    }
                }
            });
        },
        //主图点击事件
        ImgListClick(index) {
            this.currentImgIndex = index;
            this.ClickPic = '';
            this.isAutoPlay = true;
            if (index >= this.videoArr.length) {
                this.isVideoShow = false;
                let picindex = index - this.videoArr.length
                this.$nextTick(() => {
                    if (this.$refs.myCarousel) {
                        this.$refs.myCarousel.setActiveItem(picindex);
                    }
                });
                return
            }
            if (this.videoArr.length > 0) {
                if (index >= this.videoArr.length) {
                    this.isVideoShow = false;
                } else {
                    this.isVideoShow = true;
                    this.videoIndex = index;
                }
            }

        },
        handleVideoEnded() {
            let nextIndex = !this.isAutoPlay ? this.videoIndex : this.videoIndex + 1;
            this.currentImgIndex = nextIndex;
            if (nextIndex >= this.videoArr.length) {
                // nextIndex = 0; 回到第一个
                this.isVideoShow = false;
                return;
            }
            this.videoIndex = nextIndex;
            this.$nextTick(() => {
                const videoEl = this.$refs.player;
                if (videoEl) {
                    videoEl.play().catch(e => {
                        console.log('自动播放被拦截，可能需要用户交互', e);
                    });
                }
            });
        },
        // 选择面料
        selectFabric(index, data) {
            this.selectedFabric = index;
            this.currentImgIndex = 0;
            this.smallPic = [data.cover, data.image]
            this.ClickPic = blhcImageCopy(data.image);
            this.isAutoPlay = false
        },
        goLogin() {
            // 关闭当前弹窗
            this.orderShow = false;
            // 触发事件，通知TopNav打开登录框
            this.$eventBus.$emit('openLogin');
        },
        // 处理订单点击事件
        handleOrderClick() {
            this.orderShow = true;
            this.isLogin = Cookies.get('token') || '';
        },
        getInfo(productId) {
            const loading = this.$loading({
                lock: true,
                text: 'Loading',
                spinner: 'el-icon-loading',
                background: 'rgba(0, 0, 0, 0.7)'
            });
            this.loading = true;
            this.productInfo = {
                productLibraryImagePojoList: [],
                productColorPojoList: [],
                productCraftList: []
            };
            this.imageList = [];
            this.smallPic = [];
            this.videoArr = [];
            this.picArr = [];
            this.ClickPic = '';
            productLibraryDetails({ proId: productId }).then(res => {
                if (res.code == 1) {
                    this.currentImgIndex = 0;
                    this.productInfo = res.data.dataDetails;
                    this.imageList = this.productInfo.productLibraryImagePojoList || []
                    // let data = this.productInfo.productColorPojoList[0] || {}
                    // this.imageList && this.imageList.length > 0 ? '' : this.selectFabric(0, data)
                    // this.smallPic = [data.cover, data.image]
                    if (this.imageList.length > 0) {
                        this.imageList.forEach(item => {
                            this.isVideo(item.fileName) ? this.videoArr.push(item.fileName) : this.picArr.push(item.fileName);
                        })
                        this.imageList = [...this.videoArr, ...this.picArr]
                        this.videoArr.forEach((fileName, index) => {
                            let videoUrl = this.myVideo + fileName;
                            this.getVideoFrame(videoUrl, 0.5).then((base64Image) => {
                                this.$set(this.imageList, index, base64Image);
                            })
                        });
                    } else {
                        this.selectFabric(0, this.productInfo.productColorPojoList[0])
                    }

                    this.$forceUpdate();
                }
                setTimeout(() => {
                    loading.close();
                    this.loading = false;
                }, 1000);
            }).finally(() => {
                setTimeout(() => {
                    loading.close();
                    this.loading = false;
                }, 1000);
            });

        },
        isVideo(fileName) {
            return fileName && fileName.toLowerCase().endsWith('.mp4');
        },
        getVideoFrame(url, time = 1) {
            return new Promise((resolve, reject) => {
                const video = document.createElement('video');
                video.crossOrigin = 'anonymous';
                video.muted = true;
                video.autoplay = true; // 不需要自动播放
                video.preload = 'auto'; // 建议改为 auto，提高加载概率
                video.src = url;

                // 2. 监听数据加载完成，准备跳转时间
                const handleLoadedData = () => {
                    const targetTime = Math.min(time, video.duration);

                    // 如果目标时间就是0，或者视频很短，不需要seek，直接画
                    if (targetTime === 0) {
                        draw();
                    } else {
                        // 关键修改：设置时间，触发 seek 操作
                        video.currentTime = targetTime;
                    }
                };

                // 3. 关键修改：监听跳转完成事件 (seeked)
                // 只有当 seeked 触发时，画面才是真正 update 到了指定时间
                const handleSeeked = () => {
                    draw();
                };

                // 4. 绘制逻辑封装
                const draw = () => {
                    try {
                        const canvas = document.createElement('canvas');
                        canvas.width = video.videoWidth;
                        canvas.height = video.videoHeight;

                        const ctx = canvas.getContext('2d');
                        ctx.drawImage(video, 0, 0, canvas.width, canvas.height);

                        const frameBase64 = canvas.toDataURL('image/jpeg', 0.1);
                        resolve(frameBase64);
                    } catch (err) {
                        reject('截取失败(可能是跨域问题): ' + err.message);
                    } finally {
                        // 清理事件，防止内存泄漏
                        cleanup();
                    }
                };

                const handleError = (e) => {
                    cleanup();
                    reject('视频加载出错: ' + e.message);
                };

                const cleanup = () => {
                    video.removeEventListener('loadeddata', handleLoadedData);
                    video.removeEventListener('seeked', handleSeeked);
                    video.removeEventListener('error', handleError);
                    video.src = ''; // 释放资源
                    video.load();
                };

                // 绑定事件
                video.addEventListener('loadeddata', handleLoadedData);
                video.addEventListener('seeked', handleSeeked);
                video.addEventListener('error', handleError);
            });
        },
        handleResize() {
            this.screenWidth = document.documentElement.clientWidth || window.innerWidth;
            this.imgLoad();
        },
    }
};
</script>

<style>
.custom-tooltip {
    background: rgba(43, 35, 30, .8) !important;
    /* 设置你想要的背景色 */
}
</style>
<style lang="scss" scoped>
/* 字体定义 - 模拟高级衬线感 */
$font-serif: "NotoSerif", sans-serif;
$primary-color: #333;
$accent-blue: #3498db;
/* 图中的蓝色选中框颜色 */
$bg-grey: #f0f0f0;
$bg-color: #FAF9F7;


::v-deep .el-dialog__headerbtn:focus .el-dialog__close,
::v-deep .el-dialog__headerbtn:hover .el-dialog__close {
    color: #2B231E;
}

.submit-btn {
    background-color: #58473D;
    color: #fff;
    width: 100%;
    font-size: 18px;
    padding: 15px 0px;
    margin: 20px auto 0;
}

.phoneInfo {
    background: #FAF9F7;
    padding: 30px;
    box-sizing: border-box;
    width: 80%;
    margin: 30px auto;
}

.phoneInfo>div {
    display: flex;
    align-items: center;
    margin-bottom: 10px;

    div {
        margin-left: 10px;
        font-size: 18px;
        font-weight: bold;

        div {
            margin: 10px 0;
            margin-left: 20px;
        }
    }

    i {
        font-size: 24px;
        margin: 2 30px 0 30px;
        color: #888;
    }
}

.tooltip-img,
.tooltip-img img {
    width: 120px;
    height: 120px;
}

.tooltip-img {
    margin-bottom: 10px;
}

.orderTitle {
    width: 100%;
    color: #2B231E;
    word-break: break-all;
    text-align: center;
    font-size: 22px;
    margin-bottom: 10px;
    font-weight: bold;
}

.orderTxt {
    width: 100%;
    word-break: normal;
    overflow-wrap: break-word;
    white-space: normal;
    text-align: center;
}

.detail-section {
    max-width: 1400px;
    margin: 0 auto;

    .image-slot {
        display: flex;
        justify-content: center;
        align-items: center;
        width: 100%;
        height: 300px;
        /* 给一个默认高度，防止高度塌陷导致的抖动 */
        background: #f5f7fa;
        color: #909399;
        font-size: 14px;
    }
}

.luxury-home-page {
    font-family: $font-serif !important;
    color: $primary-color;
    background-color: $bg-color;
    width: 100%;
    overflow-x: hidden;
}

/* 核心容器控制：1600px */
.main-container {
    max-width: 1400px;
    margin: 0 auto;
    padding: 0 20px;
    /* 移动端防贴边 */
    box-sizing: border-box;
}

/* 2. Product Section */
.product-section {
    padding: 40px 0 150px;
}

.main-image-wrapper {
    width: 100%;
    margin-bottom: 20px;
    position: relative;
    overflow: hidden;
    min-height: 400px;

    img {
        width: 100%;
        display: block;
        object-fit: cover;
        height: auto;
    }
}

.main-image-wrapper1 {
    width: 100%;
    margin-bottom: 20px;
    position: relative;
    overflow: hidden;
    min-height: 400px;
    background-color: #ebebeb;

    img {
        width: 100%;
        display: block;
        object-fit: cover;
        height: auto;
    }
}

.thumb-list {
    display: flex;
    gap: 15px;
    overflow-x: auto;
    /* 允许横向滚动 */
    overflow-y: hidden;
    /* 禁止纵向滚动 */
    flex-wrap: nowrap;
    /* 强制不换行 */
    padding-bottom: 10px;
    /* 底部留出一点空间给滚动条，防止遮挡图片 */
    width: 100%;
    /* 占满父容器宽度 */

    &::-webkit-scrollbar {
        height: 6px;
        /* 滚动条高度 */
    }

    &::-webkit-scrollbar-thumb {
        background-color: #ccc;
        /* 滚动条滑块颜色 */
        border-radius: 3px;
    }

    &::-webkit-scrollbar-track {
        background-color: transparent;
        /* 滚动条轨道颜色 */
    }

    .thumb-item {
        width: 80px;
        height: 80px;
        cursor: pointer;
        border: 2px solid transparent;
        opacity: 0.6;
        transition: all 0.3s;
        position: relative;

        /* --- 新增关键样式 --- */
        flex-shrink: 0;
        /* 关键！防止图片变多时被挤压变形 */

        .play-icon {
            position: absolute;
            top: 50%;
            left: 50%;
            transform: translate(-50%, -50%);
            font-size: 24px;
            color: #2B231E;
            padding: 5px 10px;
            border-radius: 5px;
        }

        img {
            width: 100%;
            height: 100%;
            object-fit: cover;
        }

        &.active,
        &:hover {
            opacity: 1;
            border-color: #000;
        }
    }
}

.product-info {
    padding-left: 20px;
    /* 大屏左侧留白 */

    .product-title {
        font-family: $font-serif;
        font-size: 32px;
        margin-bottom: 20px;
    }

    .tags {
        color: #58473D;
        margin-bottom: 12px;
        font-family: $font-serif;

        span {
            margin-right: 10px;
            display: inline-block;
            background: #F7F3F0;
            padding: 5px 12px;
            border-radius: 5px;
        }
    }

    .product-desc {
        color: #666;
        line-height: 1.6;
        margin-bottom: 20px;
        font-size: 14px;
        word-break: normal;
        overflow-wrap: break-word;
        white-space: normal;
    }
}

.section-label {
    font-family: $font-serif;
    font-size: 18px;
    margin-bottom: 15px;
    font-weight: bold;
}

/* Fabric Grid - 核心尺寸逻辑 */
.fabric-grid {
    display: flex;
    flex-wrap: wrap;
    gap: 0px;
    margin-bottom: 20px;

    .fabric-item-wrapper {
        text-align: center;
        cursor: pointer;
        position: relative;
        border-radius: 4px;

        /* 110px 基础尺寸 */
        .fabric-img-box {
            width: 80px;
            height: 80px;
            margin-bottom: 5px;
            position: relative;
            background: #f9f9f9;
            border: 3px solid transparent;
            border-radius: 5px;
            overflow: hidden;

            img {
                width: 100%;
                height: 100%;
                object-fit: cover;
                border-radius: 4px;
            }

        }

        .fabric-name {
            font-size: 14px;
            color: #666;
            text-align: left;
            width: 110px;
            height: 40px;
            line-height: 20px;
            padding: 0 2px;
            box-sizing: border-box;
            display: -webkit-box;
            -webkit-line-clamp: 2;
            -webkit-box-orient: vertical;
            overflow: hidden;
            white-space: normal;
            word-wrap: break-word;

        }
    }
}

.is-selected {
    border: 3px solid #2B231E !important;
}

.production-info {
    margin-bottom: 30px;
    color: #333;
    font-size: 14px;
    line-height: 22px;

    ul {
        padding-left: 20px;
        margin-top: 5px;
    }
}

.cta-button {
    width: 100%;
    max-width: 400px;
    /* 按钮最大宽度 */
    height: 50px;
    background-color: #4a403a;
    /* 深褐色 */
    color: #fff;
    border: none;
    font-size: 14px;
    letter-spacing: 1px;
    text-transform: uppercase;
    cursor: pointer;
    transition: background 0.3s;
    font-family: $font-serif !important;

    &:hover {
        background-color: #332b27;
    }
}

.lineBreak {
    width: 100%;
    max-width: 120px;
}

.production-desc {
    white-space: pre-wrap !important;
}

@media screen and (min-width: 768px) and (max-width: 991px) {
    .product-info {
        padding-left: 0;
        margin-top: 30px;
    }
}

/* 响应式调整 */
@media screen and (max-width: 768px) {
    .product-info {
        padding-left: 0;
        margin-top: 30px;
    }

    .section-label,
    .cta-button,
    .phoneInfo div,
    .orderTxt,
    .phoneInfo i,
    div,
    p {
        font-size: 4rem !important;
    }

    .orderTitle,
    .product-title {
        font-size: 6rem !important;
    }

    .fabric-img-box,
    .thumb-item {
        width: 15rem !important;
        height: 15rem !important;
    }

    .fabric-name {
        font-size: 3rem !important;
        width: 15rem !important;
        height: 5rem !important;
        line-height: 2.5rem !important;
    }

    .cta-button {
        height: 11rem !important;
        max-width: 100% !important;
    }

    .production-desc {
        white-space: pre-wrap !important;
        line-height: 4rem !important;
    }

    .is-selected,
    .thumb-item {
        border: 0.8rem solid #2B231E !important;
    }

    .section-label {
        margin-top: 1rem !important;
        height: 6rem;
        line-height: 6rem !important;
        margin-bottom: 1rem !important;
    }

    .fabric-item-wrapper {
        margin-right: 2rem !important;
    }

    .thumb-item {
        margin-bottom: 2rem !important;
        margin-right: 1.4rem !important;
    }

    .product-title,
    .section-label {
        margin: 2rem 0 !important;
    }

    .product-info .tags {
        margin-bottom: 2rem !important;
    }

    .production-info {
        margin-bottom: 5rem !important;
    }


}

/* 过渡动画增强 */
.fade-enter-active,
.fade-leave-active {
    transition: opacity 0.5s ease, transform 1s ease;
}

/* 关键修复：离开的图片设为绝对定位，防止它占位把新图顶下去 */
.fade-leave-active {
    position: absolute;
    top: 0;
    left: 0;
    width: 100%;
    z-index: 1; // 旧图在下层淡出
}

.fade-enter-active {
    z-index: 2; // 新图在上层淡入
}

/* 离开：向左滑动并消失 */
.fade-leave-to {
    opacity: 0;
    transform: translateX(-20px);
}

/* 进入：从右侧透明处滑入 */
.fade-enter {
    opacity: 0;
    transform: translateX(20px);
}
</style>